module.exports = __webpack_public_path__ + "static/media/ill1-business.eb9e8de2.svg";